module.exports = __webpack_public_path__ + "static/media/jmeter-logo-2.5bd06fb5.webp";